
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/investor/shareholder",
      function () {
        return require("private-next-pages/ir/investor/shareholder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/investor/shareholder"])
      });
    }
  